import React from "react";
import "../index.scss"

function BlogHeading({ blogHeading }) {
  return <h3 className="blog-main-head">{blogHeading}</h3>;
}

export default BlogHeading;
